import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Utility } from 'src/app/core/common';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { DiscountService } from 'src/app/services/discount.service';
import { JobService } from 'src/app/services/job.service';
import { PaymentService } from 'src/app/services/payment.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { CommunicationEventService } from 'src/app/services/communication-event.service';
import { SharedService } from 'src/app/services/shared.service';
import { Subject, takeUntil } from 'rxjs';
import { PaymentStatus, VanguardPackage } from 'src/app/common';

@Component({
  selector: 'app-seeker-vanguard-packages',
  templateUrl: './vanguard-packages.component.html',
  styleUrls: ['./vanguard-packages.component.scss']
})
export class VanguardPackagesComponent implements OnInit {
  Utility = Utility;
  VanguardPackage = VanguardPackage;
  @Input() id: number = 1;
  user: any;
  showLogin: boolean;
  @Input() page: string;
  @Input() url: string;
  @Input() minimal: boolean;
  @Input() referer: string;

  useDiscount = false;
  discountCode: string;
  discount: any;
  invalidDiscount = false;
  toPay: number;
  amount: number;
  paymentLink: string;

  constructor(private route: ActivatedRoute, private userService: UserService, private sharedService: SharedService,
    private spinner: SpinnerService, private analyticsService: AnalyticsService,
    private discountService: DiscountService, public paymentService: PaymentService,
    private jobService: JobService, private eventLog: CommunicationEventService) {
    sharedService.me$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.load());
  }
  private unsubscribe$ = new Subject<void>();
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  Math = Math;
  totalJob: number;
  payment: any;
  async ngOnInit() {
    await this.load();
    this.eventLog.log(this.eventLog.actions.vanguard.seeker.viewPackages, { Data: { referer: this.referer } });
  }

  async load() {
    this.spinner.show('promote');

    this.user = this.sharedService.me;

    var combinedParams = { ...this.route.snapshot.params, ...this.route.snapshot.queryParams };
    if (combinedParams['pid']) {
      this.payment = await this.paymentService.get(combinedParams['pid']);
      if (this.payment?.Status == 3)
        this.analyticsService.gtmEvent('vanguard-paid', 'seeker', '', false, this.payment.Amount);
    }
    else delete this.payment;

    if (this.payment?.Status != 3)
      await this.tryBestDiscount(combinedParams['discount']);
    this.spinner.hide('promote');

    this.totalJob = await this.jobService.count();
  }

  vanguardPackages: VanguardPackage[];
  async tryBestDiscount(code?: string) {

    if (!code) code = this.discountCode;//?

    this.spinner.show('promote');
    this.invalidDiscount = false;

    this.vanguardPackages = Utility.clone(this.userService.vanguardPackages);
    let pkg = this.vanguardPackages.find(_ => _.Id == this.id) || this.vanguardPackages[0];
    this.id = pkg.Id;
    this.amount = pkg.Price;

    this.discount = !code ? null : await this.discountService.tryBest(this.discountService.types.vanguardSeeker, code);
    this.vanguardPackages.forEach(_ => {
      if (this.discount) {
        _._OriginalPrice = _.Price;
        _.Price = _.Price - (_.Price * this.discount.Percentage / 100);
      }
    });

    this.toPay = this.amount * (1 - (this.discount?.Percentage || 0) / 100);

    if (this.discount) {
      this.useDiscount = true;
      this.discountCode = this.discount.Code;
    } else {
      if (code) {
        this.invalidDiscount = true;
      }
      else {
        this.useDiscount = false;
        delete this.discount;
        delete this.discountCode;
      }
    }
    this.spinner.hide('promote');
  }

  @ViewChild('paymentModal') paymentModal: NgxSmartModalComponent;

  async pay(manualToken?: string) {
    this.spinner.show('payment');
    this.spinner.show('promote');
    await this.userService.vanguardPay(this.id, this.discount?.Id, manualToken, this.page, this.url);
    let selectedPackage = this.vanguardPackages.find(_ => _.Id == this.id);
    this.eventLog.log(this.eventLog.actions.vanguard.seeker.sentToIPG, { Data: { referer: this.referer, price: selectedPackage?.Price?.toString() } });
  }

  @Output() paymentLoaded = new EventEmitter();
  onCheckPayment(payment: any) {
    if (payment?.Status == PaymentStatus.Settled)
      this.eventLog.log(this.eventLog.actions.vanguard.seeker.paid, { Data: { referer: this.referer, price: payment.Amount } });
    this.paymentLoaded.emit(payment);
  }

  openPaymentModal(id?: number) {
    if (id) this.id = id;
    this.tryBestDiscount();

    if (!this.user) {
      this.showLogin = true;
      return;
    }

    delete this.showLogin;
    this.paymentModal.open();
    let selectedPackage = this.vanguardPackages.find(_ => _.Id == this.id);
    this.eventLog.log(this.eventLog.actions.vanguard.seeker.startPayment, { Data: { referer: this.referer, price: selectedPackage?.Price?.toString() } });

  }
}
